import api from './api';

export interface Staff {
  id: number;
  name: string;
  type?: 'active' | 'inactive';
  contact_number?: string;
  email?: string;
  team_id?: number;
  role_id?: number;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
  team?: {
    id: number;
    name: string;
  };
  role?: {
    id: number;
    name: string;
  };
}

export interface CreateStaffData {
  name: string;
  password?: string;
  type?: 'active' | 'inactive';
  contact_number?: string;
  email?: string;
  team_id?: number;
  role_id?: number;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const staffService = {
  async getAll() {
    const response = await api.get('/staffs');
    return unwrap<Staff[]>(response);
  },

  async getById(id: number): Promise<Staff> {
    const response = await api.get(`/staffs/${id}`);
    return unwrap<Staff>(response);
  },

  async create(data: CreateStaffData): Promise<Staff> {
    const response = await api.post('/staffs', data);
    return unwrap<Staff>(response);
  },

  async update(id: number, data: Partial<CreateStaffData>): Promise<Staff> {
    const response = await api.put(`/staffs/${id}`, data);
    return unwrap<Staff>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/staffs/${id}`);
  },
};
